var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBridgingtheSkillsGap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    fill: "#0089E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3085 21.6909H50.6915V39.7661L40.924 45.6602L42.556 50.9094H48.9093L43.6756 54.5774L45.7315 61.0169L40.5 57.0154L35.2663 61.0169L37.3222 54.5774L32.0907 50.9094H38.444L40.076 45.6602L30.3063 39.9781L30.3085 21.6909ZM32.5169 23.8993V37.3259C32.5169 37.7529 32.6229 38.143 32.8349 38.4963C33.0469 38.8497 33.3369 39.1397 33.705 39.3664L39.3958 42.6966V23.8993H32.5169ZM48.4831 23.8993H41.6042V42.6966L47.295 39.3664C47.6631 39.1397 47.9531 38.8497 48.1651 38.4963C48.3771 38.143 48.4831 37.7529 48.4831 37.3259V23.8993Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridgingtheSkillsGap);
export default __webpack_public_path__ + "static/media/BridgingtheSkillsGap.b544e90d8a835bab2ee410765f5af880.svg";
export { ForwardRef as ReactComponent };